import { jsx as o } from "react/jsx-runtime";
import { createContext as c, useContext as m, Children as d } from "react";
import { withManagedProps as l } from "@made-people/managed-props";
import { z as t } from "zod";
import { withZod as a } from "@made-people/react-prop-guard";
import { gridBlueprint as p } from "./index-blueprint.es.js";
import "@made-people/blueprint";
const i = c(!1), w = () => m(i), u = t.object({
  layout: t.custom().optional(),
  children: t.custom().optional()
}), y = l(
  "Grid",
  a(u, ({ layout: s, children: r }) => {
    const e = p.styles(s), n = d.count(r);
    return /* @__PURE__ */ o(i.Provider, { value: !0, children: /* @__PURE__ */ o(
      "section",
      {
        className: e.wrapper,
        style: {
          // @ts-expect-error --grid-columns is a custom property
          "--grid-columns": n
        },
        children: /* @__PURE__ */ o("div", { className: e.grid, children: r })
      }
    ) });
  })
);
export {
  y as Grid,
  i as GridContext,
  u as gridSchema,
  w as useInGrid
};
//# sourceMappingURL=index.es.js.map
